import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function ArtworkPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-24 px-6 bg-stone-50">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-wide">
            Art Inside the Poetry
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Kent's poetry books are filled with striking visual art created to enhance emotional connection and deepen interpretation. This gallery features select pieces from Nine Lives, Meta Postal Expression, and Silkfoot—each artwork paired with themes and moods from the poems they accompany.
          </p>
          <div className="w-24 h-1 bg-amber-700 mx-auto mt-8"></div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Artwork 1 - Faces */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/ee221c3ad8605306e4c4b50c436cfafa.jpeg"
                    alt="Faces"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">Faces</h3>
                    <p className="text-sm text-white/80">Silkfoot</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 2 - Resilience */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/04b1ceb4b74567eb40380d8a6ef81833.jpeg"
                    alt="Barb Wire"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">Barb Wire</h3>
                    <p className="text-sm text-white/80">Silkfoot</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 3 - Renewal */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/749c9ffbd5ad9a204a4df200c386d26f.jpeg"
                    alt="Renewal"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">Hanging Door</h3>
                    <p className="text-sm text-white/80">Silkfoot</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 4 - Messages */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/56b078d5dbc3fae33782f7faf80a73fe.jpeg"
                    alt="Messages"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">Angel Dance</h3>
                    <p className="text-sm text-white/80">Meta Postal Expression</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 5 - Connection */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/84eda3716ac62c5336f6b0e608a3c1a2.jpeg"
                    alt="Connection"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">m black to blue</h3>
                    <p className="text-sm text-white/80">Meta Postal Expression</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 6 - Memory */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/0cfc4a6e0595277b1f0f96c1ad5e1073.jpeg"
                    alt="Memory"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">...insides out</h3>
                    <p className="text-sm text-white/80">Meta Postal Expression</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 7 - Softness */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/a434309cea52b9fef8f2a4bbb1c3ee38.jpeg"
                    alt="Softness"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">GOPASSGOPASSGO</h3>
                    <p className="text-sm text-white/80">Meta Postal Expression</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 8 - Movement */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/9679d3394cb063c030d6ab90b87b49e0.jpeg"
                    alt="Movement"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">...it pokes good</h3>
                    <p className="text-sm text-white/80">Meta Postal Expression</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Artwork 9 - Presence */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-full h-96">
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/36f2d0eb32e5af4e4efdf3d9a67e1083.jpeg"
                    alt="Presence"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-light mb-1">Morell</h3>
                    <p className="text-sm text-white/80">Silkfoot</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6 bg-stone-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-wide">
            Experience the Complete Collection
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-12 leading-relaxed">
            Each artwork is part of a larger poetic journey. Explore the books to see how visual art and poetry intertwine.
          </p>
          <a
            href="/books"
            className="inline-block px-10 py-4 bg-amber-700 text-white text-sm font-light tracking-widest uppercase hover:bg-amber-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View Books
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
